document.addEventListener('DOMContentLoaded', function () {
	window.select_available_option && window.select_available_option();

	const inputsQuantity = document.querySelectorAll('quantity-input input');
	const inputsOptions = document.querySelectorAll('.product__info-container');

	const sizeChartOpen = document.querySelector('.size-chart');
	const modalSizeChart = document.querySelector('.size-chart-modal');
	const sizeChartClose = modalSizeChart?.querySelector('.icon-close');

	sizeChartOpen?.addEventListener('click', (e) => showModal(modalSizeChart));
	sizeChartClose?.addEventListener('click', (e) => hideModal(modalSizeChart));

	const current_input = document.querySelector('.product__info-container variant-selects input[data-name]:checked');

	if (!current_input) {
		inputsQuantity.forEach((input) => {
			input.addEventListener('change', (evt) => changePrice());
		});
	}

	const body = document.querySelector('body');

	if (current_input) showFlavorSlides(current_input.value);

	inputsQuantity.forEach((input) => {
		input.addEventListener('change', (evt) => {
			changePrice();
		});
	});

	inputsOptions.forEach((label) => {
		label.addEventListener('click', (evt) => {
			const target = evt.target;

			if (target && target.tagName === 'INPUT' && target.dataset.title) {
				showFlavorSlides(target.value);
			}

			if (target && target.classList.contains('size-chart')) {
				showModal(modalSizeChart);
			}
		});
	});

	modalSizeChart?.addEventListener('click', (evt) => {
		const target = evt.target;

		if (target && !target.closest('.modal-content')) hideModal(modalSizeChart);
	});

	document.addEventListener('keydown', (evt) => {
		if (evt.code === 'Escape' && modalSizeChart.classList.contains('show')) hideModal(modalSizeChart);
	});

	function showModal(modal) {
		if (!modal) return;

		modal.classList.add('show');
		modal.classList.remove('close');
		body.classList.add('no-scroll');
	}

	function hideModal(modal) {
		if (!modal) return;

		modal.classList.remove('show');
		modal.classList.add('close');
		body.classList.remove('no-scroll');
	}

	const staffParent = document.querySelector('.stuff');
	const itemsBtn = staffParent?.querySelectorAll('.content-items .btn');
	const contents = staffParent?.querySelectorAll('.content-items .wrap');

	itemsBtn?.forEach((btn, index) => {
		btn.addEventListener('click', (evt) => {
			const target = evt.target;

			if (target) {
				removeShowAttribute(itemsBtn);
				removeShowAttribute(contents);
				target.setAttribute('data-show', '');
				contents[index].setAttribute('data-show', '');
			}
		});
	});

	function removeShowAttribute(elems) {
		elems?.forEach((elem) => {
			elem.removeAttribute('data-show');
		});
	}

	const qAndAParent = document.querySelector('.q-and-a');
	const dropdownItems = qAndAParent?.querySelectorAll('.content-dropdown-items .item');

	dropdownItems?.forEach((dropdownItem) => {
		dropdownItem.addEventListener('click', (evt) => {
			const target = evt.target;

			if (target && target.closest('.item') && target.closest('.item:not([data-show])')) {
				target.closest('.item').setAttribute('data-show', '');
			} else if (target && target.closest('.item') && target.closest('.item[data-show]')) {
				target.closest('.item').removeAttribute('data-show');
			}
		});
	});

	reed_subscription_widget();
	change_flavour();

	const load_review_trigger = setInterval(() => {
		const review_toggle = document.querySelector('.fera-ratingSummary-toggle-icon');

		if (review_toggle) {
			review_toggle.addEventListener('click', () => {
				const stars_box = document.querySelectorAll('.fera-ratingSummary-ratingItem');

				stars_box.forEach((box) => {
					if (+box.dataset.feraRatingPercentage < 1) {
						const el_with_border = box.querySelector('.fera-ratingSummary-ratingItem-histogram-bar-content');

						if (el_with_border) {
							el_with_border.style.display = 'none';
						}
					}
				});
			});

			clearInterval(load_review_trigger);
		}
	}, 1);

	setTimeout(() => {
		clearInterval(load_review_trigger);
	}, 50000);
});

function showFlavorSlides(current_option) {
	const main_variant_title = document.querySelector('.product__title .subtitle');

	let name = null;
	if (typeof current_option === 'string') {
		name = current_option.toLowerCase();
		main_variant_title.textContent =
			current_option && current_option.toLowerCase().includes('variety pack') ? 'Variety Pack' : current_option;
	} else {
		if (current_option.getAttribute('data-name') === 'flavor') {
			name = current_option.getAttribute('data-title').toLowerCase();
		} else {
			const flavors = document.querySelectorAll('input[data-name="flavor"]');
			const current_flavor = Array.from(flavors).find((input) => input.checked);
			name = current_flavor.value.toLowerCase();
		}
	}

	const main_slides = document.querySelectorAll('.slider-mobile-gutter .product__media-list .product__media-item');
	const slides = document.querySelectorAll('.thumbnail-slider .thumbnail-list .thumbnail-list__item');
	slides[0]?.parentNode?.classList.remove('hide');
	slides[0].style.display = 'block';

	const current_selected_slides = Array.from(slides).filter(
		(slide) => slide.getAttribute('data-alt')?.toLowerCase() === name,
	);

	if (current_selected_slides.length === 0) {
		slides.forEach((slide) => slide.classList.add('hide'));
		return main_slides.forEach((slide) => slide.classList.add('hide'));
	}

	main_slides.forEach((slide) => slide.classList.remove('hide'));
	slides.forEach((slide) => slide.classList.add('hide'));
	current_selected_slides.forEach((slide, index) => {
		if (index === 0) {
			const btn_trigger = slide.querySelector('.thumbnail');
			btn_trigger.click();
		}
		slide.classList.remove('hide');
	});
}

function changePrice(subscription = null) {
	const productQuantity = document.querySelector('quantity-input .quantity__input');
	const productPrice = document.querySelector('.button-price');

	if (!productPrice) return;

	const code = currencyCode(productPrice.textContent);
	const currentPrice = subscription
		? +productPrice?.dataset?.btnCompare * +productQuantity?.value
		: +productPrice?.dataset?.btnPrice * +productQuantity?.value;

	productPrice.textContent = `${code}${currentPrice.toString().replace(/00$/, '')}`;
}

function currencyCode(price) {
	return price.replace(/[0-9]/g, '');
}

function reed_subscription_widget() {
	const load_widjet = setInterval(() => {
		const widget = document.querySelector('.rc-widget');

		if (widget) {
			const inputs = widget.querySelectorAll('input.rc-radio__input');
			const current_selected = Array.from(inputs).find((input) => input.checked);

			if (current_selected.value === 'subscription') changePrice('subscription');
			else changePrice();

			inputs.forEach((input) => {
				input.addEventListener('change', () => {
					if (input.value === 'subscription') changePrice('subscription');
					else changePrice();
				});
			});

			clearInterval(load_widjet);
		}
	}, 1);

	setTimeout(() => {
		clearInterval(load_widjet);
	}, 10000);
}

function change_flavour() {
	const url = new URL(window.location.href);
	const variantID = +url.searchParams.get('variant');

	const variant_texts = document.querySelectorAll('.stuff .content-items .text-wrapper');
	element_enable(variantID, variant_texts);
}

onUrlChange(() => {
	change_flavour();
	window.addComparePriceSubscription();
});

function element_enable(ID, elements) {
	if (!elements.length) return;
	elements.forEach((elem) => elem.classList.add('hide'));
	const current_variants = Array.from(elements).filter((elem) => +elem.dataset.variantId === ID);
	current_variants.forEach((variant) => variant.classList.remove('hide'));

	if (current_variants.length === 0) {
		const variant_texts_wrap = document.querySelectorAll('.stuff .content-items .wrap');
		variant_texts_wrap.forEach((item) => {
			const variant_texts = item.querySelectorAll('.stuff .content-items .text-wrapper');
			variant_texts[0].classList.remove('hide');
		});

		elements[0].classList.remove('hide');
	}
	// elements.classList.remove('hide');
}

function onUrlChange(callback) {
	let lastUrl = window.location.href;
	const observer = new MutationObserver(() => {
		const currentUrl = window.location.href;
		if (currentUrl !== lastUrl) {
			lastUrl = currentUrl;
			callback(currentUrl);
		}
	});

	observer.observe(document, { subtree: true, childList: true });
}
